import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Core/Header";
import { Section } from "../Core/Section";
import { useSelector } from "react-redux";
import { approveEmployeeLeave, doctorList, employeeLeaveApply, fetchStoreExpenditure, getAllAvailableDates, getAlLeaveApplyByEmployee, getAvailableLeaves, getCheckoutList, getListServiceReminderCallingPerson, getListServiceReminderCallingPersonInProgress, gstAllLeaveTypes, markCompleteServiceReminder, patientList, replyUserSupportChats, setNewAvailableDates, updateServiceReminderFollowup, userSupportChats, userSupportMessages } from "../Services/Operations/ProductAPI";
import { toast } from "react-toastify";


/* Small reusable "more" dropdown used by the cards (same items as before) */
const MoreMenu = () => (
  <div className="item-action dropdown ml-2">
    <a href="javascript:void(0)" data-toggle="dropdown" className="rh-more">
      <i className="fa fa-ellipsis-v" />
    </a>
    <div className="dropdown-menu dropdown-menu-right rh-more-menu">
      <a href="javascript:void(0)" className="dropdown-item">
        <i className="dropdown-icon fa fa-eye" /> View Details{" "}
      </a>
      <a href="javascript:void(0)" className="dropdown-item">
        <i className="dropdown-icon fa fa-share-alt" /> Share{" "}
      </a>
      <a href="javascript:void(0)" className="dropdown-item">
        <i className="dropdown-icon fa fa-cloud-download" /> Download
      </a>
      <div className="dropdown-divider" />
      <a href="javascript:void(0)" className="dropdown-item">
        <i className="dropdown-icon fa fa-copy" /> Copy to
      </a>
      <a href="javascript:void(0)" className="dropdown-item">
        <i className="dropdown-icon fa fa-folder" /> Move to
      </a>
      <a href="javascript:void(0)" className="dropdown-item">
        <i className="dropdown-icon fa fa-edit" /> Rename
      </a>
      <a href="javascript:void(0)" className="dropdown-item">
        <i className="dropdown-icon fa fa-trash" /> Delete
      </a>
    </div>
  </div>
);

const Home = () => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);
  const [patient, setPatient] = useState([]);
  const [storeExpen, setStoreExpen] = useState([]);
  const [storeModal, setStoreModal] = useState(false);
  const [availabilityModal, setAvailabilityModal] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [availableLeaves, setAvailableLeaves] = useState([]);
  const [appliedLeaves, setAppliedLeaves] = useState([]);
  const [assignedTaskForcallerperson, setAssignedTaskForcallerperson] = useState([]);
  const [assignedTaskForcallerpersonInprogress, setAssignedTaskForcallerpersonInprogress] = useState([]);

  const [servicelistType, setServicelistType] = useState(1);
  const userRole = localStorage.getItem("role");
  const raw = localStorage.getItem("empRole");

  const roleId = raw && raw !== "undefined" ? JSON.parse(raw) : null;
  const [empId, setEmpid] = useState(roleId?.roleId);

  const [currentService, setCurrentService] = useState(null); // to follow up
  const [followUpNote, setFollowUpNote] = useState("");
  const [nextFollowUpAt, setNextFollowUpAt] = useState(null);
  const [createdCheckout, setCreatedCheckout] = useState([]);
  const [leaveForm, setLeaveForm] = useState({
    leaveTypeId: null,
    startDate: "",
    endDate: "",
    reason: "",
  });

  const dateFormat = (timestamp) => {
    const dateOnly = new Date(timestamp).toISOString().split("T")[0];
    return dateOnly;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setLeaveForm((prev) => ({
      ...prev,
      [name]: name === "leaveTypeId" ? Number(value) : value,
    }));
  };

  useEffect(() => {
    const fetchPatientList = async () => {
      try {
        const response = await patientList(token);
        setPatient(response);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchPatientList();
  }, []);

  const [doctors, setDoctors] = useState([]);
  const [chats, setChats] = useState([]);
  const [supportModal, setSupportModal] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [supportMessage, setSupportMessage] = useState("");

  const [availableDates, setAvailabeDates] = useState([]);
  const [newAvDate, setNewAvDate] = useState([{ date: [2, 3, 4], isAvailable: true }]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;

  const currentChats = chats.slice(indexOfFirst, indexOfLast);

  const handlegetStoreExpenditure = async () => {
    try {
      const response = await fetchStoreExpenditure(token);
      console.log("handlegetStoreExpenditure", response);
      if (response.status === 200) {
        setStoreExpen(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    const fetchDoctorList = async () => {
      try {
        const response = await doctorList(token);
        setDoctors(response);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    const fetchUserSupportList = async () => {
      try {
        const response = await userSupportMessages(token);
        console.log("fetchUserSupportList", response);
        if (response.status === 200) {
          setChats(response.data);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    handlegetStoreExpenditure();
    fetchDoctorList();
    fetchUserSupportList();
  }, []);

  const getSupportChats = async (chat) => {
    try {
      setSupportModal(chat);
      let data = {
        token,
        id: chat.supportId,
      };
      const response = await userSupportChats(data);
      console.log(response);
      setConversations(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetAllLeaveTypes = async () => {
    try {
      const response = await gstAllLeaveTypes(token);
      console.log("all leave types", response.data);
      if (response.status === 200) {
        setLeaveTypes(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetAvailableEmpLeaves = async () => {
    try {
      const response = await getAvailableLeaves(token);
      console.log("all leave types", response.data);
      if (response.status === 200) {
        setAvailableLeaves(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetAllLeaveApplyByEmployee = async () => {
    try {
      const response = await getAlLeaveApplyByEmployee(token);
      console.log("getAlLeaveApplyByEmployee", response);
      if (response.status === 200) {
        setAppliedLeaves(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCheckouts = async () => {
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const response = await getCheckoutList(token);
      console.log("Checkout List: ", response);

      const created = response.filter((item) => item.orderStatus === "CREATED");
      setCreatedCheckout(created);
    } catch (error) {
      console.log(error);
    }
  };

  const handleReplySupportChat = async () => {
    let data = {
      id: supportModal.supportId,
      message: supportMessage,
      token,
    };
    try {
      const response = await replyUserSupportChats(data);
      console.log(response);
      if (response.status === 200) {
        getSupportChats(supportModal);
        setSupportMessage("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCheckouts();

    if (userRole === "1") {
      handleGetAllLeaveTypes();
    } else {
      handleGetAvailableEmpLeaves();
    }
    handleGetAllLeaveApplyByEmployee();
  }, []);

  useEffect(() => {
    if (empId === 6) {
      handleGetServiceReminderForcallingPerson();
      handleGetServiceReminderForcallingPersonInProgress();
    }
  }, []);

  const handleApplyLeave = async () => {
    try {
      console.log("handleApplyLeave", leaveForm);

      const response = await employeeLeaveApply(leaveForm, token);
      console.log("handleApplyLeave", response);
      if (response.status === 200) {
        toast.success(response.data.message);
        setLeaveForm({ leaveTypeId: null, startDate: "", endDate: "", reason: "" });
      } else if (response.status === 400) {
        toast.info(response.data.message);
      }
    } catch (error) {
      toast.error(error.data.message);
      console.log(error);
    }
  };

  const handleApproaveLeave = async (data) => {
    try {
      const response = await approveEmployeeLeave(data, token);
      console.log(response);
      if (response.status === 200) {
        toast.success(response.data.message);
        handleGetAllLeaveApplyByEmployee();
      }
    } catch (error) {
      console.log();
      toast.error("Failed to approve leave");
    }
  };
  const handleGetServiceReminderForcallingPerson = async () => {
    try {
      const response = await getListServiceReminderCallingPerson(token);
      console.log("getListServiceReminderCallingPerson", response);
      if (response.status === 200) {
        const list = response.data.data.filter((i) => i.serviceScheduleWorkStatus === "ASSIGNED");
        setAssignedTaskForcallerperson(list);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetServiceReminderForcallingPersonInProgress = async () => {
    try {
      const response = await getListServiceReminderCallingPersonInProgress(token);
      console.log("getListServiceReminderCallingPerson", response);
      if (response.status === 200) {
        const list = response.data.data.filter((i) => i.serviceScheduleWorkStatus === "IN_PROGRESS");
        setAssignedTaskForcallerpersonInprogress(list);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitFollowup = async (serviceScheduleAssignmentId) => {
    try {
      let data = {
        serviceScheduleAssignmentId,
        nextFollowUpAt,
        note: followUpNote,
        token,
      };

      const response = await updateServiceReminderFollowup(data);
      console.log(response);
      if (response.status === 200) {
        setCurrentService(null);
        toast.success("Next follow up updated");
        handleGetServiceReminderForcallingPerson();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitMarkCompleteServiceReminder = async (serviceScheduleAssignmentId) => {
    try {
      let data = {
        serviceScheduleAssignmentId,

        note: "Service completed successfully",
        token,
      };

      const response = await markCompleteServiceReminder(data);
      console.log(response);
      if (response.status === 200) {
        setCurrentService(null);
        toast.success("The service reminder completed,assign service person");
        handleGetServiceReminderForcallingPerson();
        handleGetServiceReminderForcallingPersonInProgress();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const dateFormat2 = (date) => {
    const formattedDate = new Date(date).toLocaleDateString("en-IN", {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
    return formattedDate;
  };

  const handleGetAvailabeDates = async () => {
    try {
      const res = await getAllAvailableDates(token);
      console.log("getAllAvailableDates", res);
      setAvailabeDates(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSetAvailabeDates = async () => {
    try {
      let data = {
        availabilities: [{ isAvailable: true, date: newAvDate }],
      };
      const res = await setNewAvailableDates(data, token);
      console.log("getAllAvailableDates", res);
      if (res.status === 200) {
        toast.success("New availability date added");
        setNewAvDate([]);
        handleGetAvailabeDates();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formatDate = (dateArr) => {
    const [year, month, day] = dateArr;

    return `${year}/${String(month).padStart(2, "0")}/${String(day).padStart(2, "0")}`;
  };

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }

    handleGetAvailabeDates();
  }, [token, navigate]);

  /* Same table is used for "new assigned" and "in progress" lists */
  const renderServiceTable = (list) => (
    <div className="rh-table-wrap">
      <table className="rh-table">
        <thead>
          <tr>
            <th>Id</th>
            <th>Patient</th>
            <th>patient Number</th>
            <th>Patient Email</th>
            <th>Status</th>
            <th>Assigned Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {list.length > 0 &&
            list?.map((item, ind) => (
              <tr key={ind}>
                <td>{ind + 1}</td>
                <td>
                  {item.customerFirstName} {item.customerLastName}
                </td>
                <td>{item.customerPhone}</td>
                <td>{item.customerEmail}</td>

                <td>
                  <span className="rh-pill">{item.serviceScheduleWorkStatus}</span>
                </td>
                <td>{item.assignedAt}</td>

                <td className="rh-actions">
                  <button className="rh-btn rh-btn-red rh-btn-sm" onClick={() => setCurrentService(ind)}>
                    <i className="fa fa-phone" /> Follow up
                  </button>

                  <button
                    className="rh-btn rh-btn-outline rh-btn-sm"
                    onClick={() => handleSubmitMarkCompleteServiceReminder(item.assignmentId)}
                  >
                    <i className="fa fa-check" /> Complete
                  </button>
                  {currentService === ind && (
                    <div className="rh-popover">
                      <p className="rh-popover-close" onClick={() => setCurrentService(null)}>
                        <i className="fa fa-times" />
                      </p>
                      <p className="rh-popover-title">Put in Follow Up for {ind + 1} service</p>
                      <textarea
                        className="rh-input"
                        placeholder="Write a note"
                        value={followUpNote}
                        onChange={(e) => setFollowUpNote(e.target.value)}
                        style={{ width: "100%", height: "140px" }}
                      ></textarea>
                      <label className="rh-label">Next follow up date</label>
                      <input
                        className="rh-input"
                        type="date"
                        value={nextFollowUpAt}
                        onChange={(e) => setNextFollowUpAt(e.target.value)}
                      />
                      <button
                        className="rh-btn rh-btn-red"
                        onClick={() => handleSubmitFollowup(item.assignmentId)}
                      >
                        Follow Up
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {!(list.length > 0) && (
        <p className="rh-empty">
          <i className="fa fa-inbox" /> No records found,table is empty
        </p>
      )}
    </div>
  );

  return (
    <div id="main_content">
      <Header />
      <div className="page rh-page">
        <Section />

        {/* ================= PAGE TITLE ================= */}
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center rh-title-bar">
              <div className="header-action">
                <h1 className="page-title rh-title">Dashboard</h1>
                <ol className="breadcrumb page-breadcrumb rh-crumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Dashboard
                  </li>
                </ol>
              </div>
              <ul className="nav nav-tabs page-header-tab rh-tabs">
                <li className="nav-item">
                  <a className="nav-link active" data-toggle="tab" href="#admin-Dashboard">
                    <i className="fa fa-th-large" /> Dashboard
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* ================= STAT CARDS ================= */}
        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="row clearfix row-deck">
              {/* Patients */}
              <div
                onClick={() => navigate("/patient")}
                style={{ cursor: "pointer" }}
                className="col-lg-3 col-md-6 col-sm-6 cursor-pointer"
              >
                <div className="card overflow-hidden rh-stat">
                  <div className="card-body">
                    <span className="rh-stat-icon">
                      <i className="fa fa-heartbeat" />
                    </span>
                    <div className="rh-stat-label">Patients</div>
                    <div>
                      <span className="rh-stat-value">Total {patient.length} patients</span>{" "}
                      <span className="rh-trend rh-trend-down">
                        <i className="fa fa-level-down" /> 08%
                      </span>
                    </div>
                    <small className="rh-stat-note">Analytics for last week</small>
                  </div>
                  <div className="rh-bar-track">
                    <div className="rh-bar-fill" style={{ width: "35%" }} />
                  </div>
                </div>
              </div>

              {/* Appointment dates (role 1) / Doctor */}
              {userRole === "1" ? (
                <div onClick={() => setAvailabilityModal(true)} className="col-lg-3 col-md-6 col-sm-6">
                  <div className="card overflow-hidden rh-stat">
                    <div className="card-body">
                      <span className="rh-stat-icon">
                        <i className="fa fa-calendar-check-o" />
                      </span>
                      <div className="rh-stat-label">Available Appoinment Date</div>
                      <div>
                        <span className="rh-stat-value rh-big">{availableDates.length}</span>{" "}
                        <span className="rh-trend rh-trend-up">
                          <i className="fa fa-level-up" />
                        </span>
                      </div>
                      <small className="rh-stat-note">Analytics for last week</small>
                    </div>
                    <div className="rh-bar-track">
                      <div className="rh-bar-fill" style={{ width: "85%" }} />
                    </div>
                  </div>

                  {availabilityModal && (
                    <div className="rh-modal">
                      <p
                        className="rh-modal-close"
                        onClick={(e) => {
                          e.stopPropagation();
                          setAvailabilityModal(false);
                        }}
                      >
                        <i className="fa fa-times" />
                      </p>

                      <div className="rh-modal-head">
                        <p className="rh-modal-title">Add new availabe date for Medical test</p>
                        <input
                          className="rh-input"
                          type="date"
                          value={newAvDate}
                          onChange={(e) => setNewAvDate(e.target.value)}
                        />
                        <p className="rh-btn rh-btn-red rh-btn-sm rh-inline" onClick={() => handleSetAvailabeDates()}>
                          <i className="fa fa-plus" /> Add
                        </p>
                      </div>

                      {availableDates.map((item, ind) => (
                        <div className="rh-date-row" key={ind}>
                          <p className="rh-date-main">
                            Date : <span>{item?.date ? formatDate(item?.date) : ""}</span>
                          </p>

                          <p>Availabe:{item?.isAvailable ? "true" : "false"}</p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <div
                  onClick={() => navigate("/doctor")}
                  style={{ cursor: "pointer" }}
                  className="col-lg-3 col-md-6 col-sm-6"
                >
                  <div className="card overflow-hidden rh-stat">
                    <div className="card-body">
                      <span className="rh-stat-icon">
                        <i className="fa fa-user-md" />
                      </span>
                      <div className="rh-stat-label">Doctor</div>
                      <div>
                        <span className="rh-stat-value">Total {doctors.length} doctors</span>{" "}
                        <span className="rh-trend rh-trend-up">
                          <i className="fa fa-level-up" /> 24%
                        </span>
                      </div>
                      <small className="rh-stat-note">Analytics for last week</small>
                    </div>
                    <div className="rh-bar-track">
                      <div className="rh-bar-fill" style={{ width: "50%" }} />
                    </div>
                  </div>
                </div>
              )}

              {/* Store expenditure */}
              <div onClick={() => setStoreModal(!storeModal)} className="col-lg-3 col-md-6 col-sm-6">
                <div className="card overflow-hidden rh-stat">
                  <div className="card-body">
                    <span className="rh-stat-icon">
                      <i className="fa fa-inr" />
                    </span>
                    <div className="rh-stat-label">Store Expenditure</div>
                    <div>
                      <span className="rh-stat-value rh-big">89</span>{" "}
                      <span className="rh-trend rh-trend-up">
                        <i className="fa fa-level-up" /> 15%
                      </span>
                    </div>
                    <small className="rh-stat-note">Analytics for last week</small>
                  </div>
                  <div className="rh-bar-track">
                    <div className="rh-bar-fill" style={{ width: "85%" }} />
                  </div>
                </div>
                {storeExpen.length > 0 && <div className="rh-count-badge">{storeExpen.length}</div>}
                {storeModal && (
                  <div className="rh-modal">
                    <div className="rh-modal-head">
                      <p className="rh-modal-title">
                        <i className="fa fa-inr" /> Store Expenditure
                      </p>
                    </div>
                    {storeExpen.map((item, ind) => (
                      <div className="rh-date-row" key={ind}>
                        <p className="rh-exp-name">
                          {item.storeName}
                          <span>({item.storeTypeName})</span>
                        </p>
                        <p>
                          {item.personName},{item.personContact}
                        </p>
                        <p>
                          Purpose:{item.purpose},Ammout:{item.amount}
                        </p>
                        <p>
                          Date:{item.expenditureDate[0]}/{item.expenditureDate[1]}/{item.expenditureDate[2]}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Confirm new orders */}
              <div onClick={() => navigate("/confirm-checkout")} className="col-lg-3 col-md-6 col-sm-6">
                <div className="card overflow-hidden rh-stat rh-stat-hot">
                  <div className="card-body">
                    <span className="rh-stat-icon">
                      <i className="fa fa-shopping-cart" />
                    </span>
                    <div className="rh-stat-label"style={{color:"black"}}>Confirm new orders</div>
                    <div>
                      <span className="rh-stat-value rh-big"style={{color:"red"}}>{createdCheckout.length}</span>{" "}
                    </div>
                     <small className="rh-stat-note">New Orders</small>
                  </div>
                  
                </div>
              </div>
            </div>

            {/* ================= SERVICE REMINDER (empId 6) ================= */}
            {empId === 6 && (
              <div className="rh-panel" style={{ cursor: "pointer" }}>
                <div className="rh-panel-head">
                  <p className="rh-panel-title">
                    <i className="fa fa-bell" /> Service Reminder List
                  </p>
                  <div className="rh-switch">
                    <p
                      onClick={() => setServicelistType(1)}
                      className={servicelistType === 1 ? "is-on" : ""}
                    >
                      New assigned Service Reminder List
                    </p>
                    <p
                      onClick={() => setServicelistType(2)}
                      className={servicelistType === 2 ? "is-on" : ""}
                    >
                      In progress assigned Service Reminder List
                    </p>
                  </div>
                </div>
                {servicelistType === 1
                  ? renderServiceTable(assignedTaskForcallerperson)
                  : renderServiceTable(assignedTaskForcallerpersonInprogress)}
              </div>
            )}

            <div className="tab-content">
              <div className="tab-pane fade show active" id="admin-Dashboard" role="tabpanel">
                <div className="row clearfix">
                  <div className="">
                    {userRole === "1" ? (
                      <div className="card rh-card">
                        <div className="card-header rh-card-head">
                          <h3 className="card-title">
                            <i className="fa fa-calendar-o" /> Available Employee Leave
                          </h3>
                        </div>
                        <div className="card-body">
                          <div className="rh-table-wrap">
                            <table className="rh-table table table-hover table-vcenter table-striped mb-0 text-nowrap">
                              <thead>
                                <tr style={{ textAlign: "center" }}>
                                  <th>Id</th>
                                  <th style={{ textAlign: "center" }}>LeaveName</th>

                                  <th style={{ textAlign: "center" }}>Frequency</th>
                                  <th style={{ textAlign: "center" }}>Max Allowed</th>
                                  <th style={{ textAlign: "center" }}>Min Tenure Years</th>
                                  <th style={{ textAlign: "center" }}>Max Lifetime</th>
                                  <th style={{ textAlign: "center" }}>Is Special Rule</th>
                                </tr>
                              </thead>

                              <tbody>
                                {leaveTypes?.map((leave, index) => (
                                  <tr key={leave?.id}>
                                    <td>{index + 1}</td>

                                    <td>
                                      <span className="font-16">{leave.leaveName}</span>
                                    </td>

                                    <td>{leave.frequency}</td>
                                    <td>{leave.maxAllowed}</td>
                                    <td>{leave.minTenureYears}</td>
                                    <td>{leave.maxLifetime}</td>
                                    <td>{leave.isSpecialRule}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="card rh-card">
                        <div className="card-header rh-card-head">
                          <h3 className="card-title">
                            <i className="fa fa-paper-plane-o" /> Employee Leave Apply
                          </h3>
                        </div>
                        <div className="card-body rh-leave-body">
                          <div className="rh-leave-form">
                            <label className="rh-label">Select Leave Type</label>
                            <select
                              className="rh-input"
                              name="leaveTypeId"
                              value={leaveForm.leaveTypeId}
                              onChange={handleChange}
                            >
                              <option value="">Select a Leave type</option>
                              {availableLeaves?.map((leave) => (
                                <option key={leave.id} value={Number(leave.id)}>
                                  {leave.leaveName}
                                </option>
                              ))}
                            </select>

                            <label className="rh-label">Enter Start Date</label>
                            <input
                              className="rh-input"
                              type="date"
                              name="startDate"
                              value={leaveForm.startDate}
                              onChange={handleChange}
                            />

                            <label className="rh-label">Enter End Date</label>
                            <input
                              className="rh-input"
                              type="date"
                              name="endDate"
                              value={leaveForm.endDate}
                              onChange={handleChange}
                            />

                            <label className="rh-label">Enter Reason</label>
                            <textarea
                              className="rh-input"
                              name="reason"
                              placeholder="Enter Reason to take leave"
                              value={leaveForm.reason}
                              onChange={handleChange}
                              style={{ width: "100%" }}
                            />
                            <button className="rh-btn rh-btn-red" onClick={handleApplyLeave}>
                              <i className="fa fa-send" /> Apply
                            </button>
                          </div>

                          <div className="rh-leave-side">
                            <div className="rh-table-wrap">
                              <table className="rh-table table table-hover table-vcenter table-striped mb-0 text-nowrap">
                                <thead>
                                  <tr style={{ textAlign: "center" }}>
                                    <th>Id</th>
                                    <th style={{ textAlign: "center" }}>LeaveName</th>

                                    <th style={{ textAlign: "center" }}>Remaining</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {availableLeaves?.map((leave, index) => (
                                    <tr key={leave?.id}>
                                      <td>{index + 1}</td>

                                      <td>
                                        <span className="font-16">{leave.leaveName}</span>
                                      </td>

                                      <td>
                                        <span className="rh-pill">{leave.remaining}</span>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Employee Leave List */}
                  <div className="">
                    <div className="card rh-card" style={{ height: "" }}>
                      <div className="card-header rh-card-head">
                        <h3 className="card-title">
                          <i className="fa fa-list-alt" /> Employee Leave List
                        </h3>
                        <div className="card-options">
                          <a href="#" className="card-options-collapse" data-toggle="card-collapse">
                            <i className="fa fa-chevron-up" />
                          </a>
                          <a href="#" className="card-options-fullscreen" data-toggle="card-fullscreen">
                            <i className="fa fa-expand" />
                          </a>
                          <a href="#" className="card-options-remove" data-toggle="card-remove">
                            <i className="fa fa-times" />
                          </a>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="rh-table-wrap">
                          <table className="rh-table table table-hover table-vcenter table-striped mb-0 text-nowrap">
                            <thead>
                              <tr style={{ textAlign: "center" }}>
                                <th>Id</th>
                                <th style={{ textAlign: "center" }}>Employee Name</th>

                                <th style={{ textAlign: "center" }}>Leave Type</th>
                                <th style={{ textAlign: "center" }}>Date</th>
                                <th style={{ textAlign: "center" }}>Reason</th>
                                <th style={{ textAlign: "center" }}>Status</th>
                                <th style={{ textAlign: "center" }}>Action</th>
                              </tr>
                            </thead>

                            <tbody>
                              {appliedLeaves?.map((leave, index) => (
                                <tr key={leave?.id}>
                                  <td>{index + 1}</td>

                                  <td>
                                    <span className="font-16">{leave.employeeName}</span>
                                  </td>

                                  <td>{leave.leaveTypeName}</td>
                                  <td>
                                    {dateFormat(leave.startDate)} to {dateFormat(leave.endDate)}
                                  </td>
                                  <td>{leave.reason}</td>
                                  <td>
                                    <span className="rh-pill">{leave.status}</span>
                                  </td>
                                  <td>
                                    {leave.status === "PENDING" ? (
                                      <button
                                        className="rh-btn rh-btn-red rh-btn-sm"
                                        onClick={() =>
                                          handleApproaveLeave({ leaveId: leave.leaveId, action: "APPROVE" })
                                        }
                                      >
                                        <i className="fa fa-check" /> Approve
                                      </button>
                                    ) : (
                                      <p className="rh-done">
                                        <i className="fa fa-check-circle" /> Done
                                      </p>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ================= CUSTOMER SUPPORT ================= */}
                <div>
                  <div className="card rh-card">
                    <div className="card-header rh-card-head">
                      <h3 className="card-title">
                        <i className="fa fa-headphones" /> Customer Support requests
                      </h3>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive rh-table-wrap" style={{ minHeight: 310, width: "100%" }}>
                        <table className="rh-table table table-hover table-vcenter table-striped mb-0 text-nowrap">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Customer Name</th>
                              <th>Support Type</th>
                              <th>Support Status</th>
                              <th>Support Date</th>
                              <th>Product id</th>
                              <th>Order Id</th>
                              <th>Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentChats.map((doctor, ind) => (
                              <tr key={ind}>
                                <td>{ind + 1}</td>
                                <td>{doctor.userName}</td>
                                <td>{doctor.supportType}</td>
                                <td>
                                  <span className="rh-pill">{doctor.supportStatus}</span>
                                </td>
                                <td>
                                  {doctor.createdAt[0]}/{doctor.createdAt[1]}/{doctor.createdAt[2]}
                                </td>
                                <td>{doctor.productId}</td>
                                <td>{doctor.checkoutId}</td>
                                <td className="rh-chat-open" onClick={() => getSupportChats(doctor)}>
                                  <img src="/assets/images/customer-service.png" />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {supportModal && (
                        <div className="rh-chat">
                          <div className="rh-chat-head">
                            <span>
                              <i className="fa fa-comments" /> Support chat
                            </span>
                            <p className="rh-chat-close" onClick={() => setSupportModal(null)}>
                              <i className="fa fa-times" />
                            </p>
                          </div>
                          <div className="rh-chat-body">
                            {conversations.map((chat, i) => (
                              <p key={i} className="rh-chat-msg">
                                {chat.message}
                              </p>
                            ))}
                          </div>
                          <div className="rh-chat-send">
                            <textarea
                              placeholder="Reply to messages...."
                              value={supportMessage}
                              onChange={(e) => setSupportMessage(e.target.value)}
                            ></textarea>
                            <p className="rh-chat-btn" onClick={() => handleReplySupportChat()}>
                              <i className="fa fa-paper-plane" /> Send
                            </p>
                          </div>
                        </div>
                      )}
                      <div className="pagination mt-3 rh-pager">
                        <button
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage((prev) => prev - 1)}
                          className="btn btn-primary btn-sm me-2 rh-btn rh-btn-red rh-btn-sm"
                        >
                          <i className="fa fa-angle-left" /> Prev
                        </button>

                        <span>
                          {" "}
                          Page {currentPage} of {Math.ceil(chats.length / itemsPerPage)}{" "}
                        </span>

                        <button
                          disabled={currentPage === Math.ceil(chats.length / itemsPerPage)}
                          onClick={() => setCurrentPage((prev) => prev + 1)}
                          className="btn btn-primary btn-sm ms-2 rh-btn rh-btn-red rh-btn-sm"
                        >
                          Next <i className="fa fa-angle-right" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ================= DOCTORS + EMPLOYEE PERFORMANCE ================= */}
                <div className="row clearfix row-deck">
                  <div className="col-xl-6 col-lg-6 col-md-12">
                    <div className="card rh-card">
                      <div className="card-header rh-card-head">
                        <h3 className="card-title">
                          <i className="fa fa-user-md" /> Doctor reference Performance
                        </h3>
                        <div className="card-options">
                          <a href="#" className="card-options-collapse" data-toggle="card-collapse">
                            <i className="fa fa-chevron-up" />
                          </a>
                          <MoreMenu />
                        </div>
                      </div>
                      <div className="table-responsive rh-table-wrap" style={{ height: 310 }}>
                        <table className="rh-table table table-hover table-vcenter table-striped mb-0 text-nowrap">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Name</th>
                              <th>Gender</th>
                              <th>Number</th>
                              <th>Profession</th>
                              <th>Specialization</th>
                              <th>number Of Co</th>
                              <th>State</th>
                            </tr>
                          </thead>
                          <tbody>
                            {doctors.map((doctor) => (
                              <tr key={doctor.id}>
                                <td>{doctor.id}</td>
                                <td>
                                  {doctor.firstName} {doctor.middleName} {doctor.lastName}
                                </td>
                                <td>{doctor.gender}</td>
                                <td>{doctor.primaryNumber}</td>
                                <td>{doctor.profession}</td>
                                <td>{doctor.specialization}</td>
                                <td>{doctor.numberOfCo}</td>
                                <td>{doctor.state}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="card-footer d-flex justify-content-between rh-card-foot">
                        <div className="font-14">
                          <span>
                            Measure How Fast You’re Growing Monthly Recurring Revenue. <a href="#">View All</a>
                          </span>
                        </div>
                        <div>
                          <button type="button" className="btn btn-primary rh-btn rh-btn-red">
                            <i className="fa fa-download" /> Export
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-12">
                    <div className="card rh-card">
                      <div className="card-header rh-card-head">
                        <h3 className="card-title">
                          <i className="fa fa-line-chart" /> Employee Performance
                        </h3>
                        <div className="card-options">
                          <a href="#" className="card-options-collapse" data-toggle="card-collapse">
                            <i className="fa fa-chevron-up" />
                          </a>
                        </div>
                      </div>
                      <div className="card-body">
                        <div id="apex-DeviceusebyStudent" />
                      </div>
                      <div className="card-footer rh-card-foot">
                        <div className="d-flex text-center">
                          <div className="p-2 flex-fill">
                            <span className="text-muted">Ishani Ma'am</span>
                            <h5>1.08K</h5>
                            <small className="rh-trend rh-trend-up">
                              <i className="fa fa-angle-up" /> 1.03%
                            </small>
                          </div>
                          <div className="p-2 flex-fill">
                            <span className="text-muted">Saifuddin</span>
                            <h5>3.20K</h5>
                            <small className="rh-trend rh-trend-down">
                              <i className="fa fa-angle-down" /> 1.63%
                            </small>
                          </div>
                          <div className="p-2 flex-fill">
                            <span className="text-muted">Kishore Sir</span>
                            <h5>8.18K</h5>
                            <small className="rh-trend rh-trend-up">
                              <i className="fa fa-angle-up" /> 4.33%
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ================= PATIENT LIST ================= */}
                <div className="row">
                  <div className="col-md-12">
                    <div className="card rh-card">
                      <div className="card-header rh-card-head">
                        <h3 className="card-title">
                          <i className="fa fa-heartbeat" /> Patient List
                        </h3>
                        <div className="card-options">
                          <a href="#" className="card-options-collapse" data-toggle="card-collapse">
                            <i className="fa fa-chevron-up" />
                          </a>
                          <a href="#" className="card-options-fullscreen" data-toggle="card-fullscreen">
                            <i className="fa fa-expand" />
                          </a>
                          <a href="#" className="card-options-remove" data-toggle="card-remove">
                            <i className="fa fa-times" />
                          </a>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive rh-table-wrap">
                          <table className="rh-table table table-hover js-basic-example dataTable table-striped table_custom border-style spacing5">
                            <thead>
                              <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Gender</th>
                                <th>Number</th>
                                <th>Blood Group</th>
                                <th>State</th>
                              </tr>
                            </thead>
                            <tbody>
                              {patient.map((patient) => (
                                <tr key={patient.id}>
                                  <td>{patient.id}</td>
                                  <td>
                                    {patient.firstName} {patient.middleName} {patient.lastName}
                                  </td>
                                  <td>{patient.gender}</td>
                                  <td>{patient.primaryNumber}</td>
                                  <td>
                                    <span className="rh-pill">{patient.bloodGroup}</span>
                                  </td>
                                  <td>{patient.state}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ================= HIDDEN "Activity" TAB (kept as before) ================= */}
              <div className="tab-pane fade" id="admin-Activity" role="tabpanel">
                <div className="row clearfix row-deck">
                  <div className="col-xl-7 col-lg-6 col-md-12">
                    <div className="card rh-card">
                      <div className="card-header rh-card-head">
                        <h3 className="card-title">Quick Mail</h3>
                        <div className="card-options">
                          <a href="javascript:void(0)" className="card-options-remove" data-toggle="card-remove">
                            <i className="fa fa-times" />
                          </a>
                          <MoreMenu />
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text w80">To:</span>
                          </div>
                          <input type="text" className="form-control" />
                          <div className="input-group-append">
                            <span className="input-group-text">CC BCC</span>
                          </div>
                        </div>
                        <div className="input-group mt-1 mb-3">
                          <div className="input-group-prepend">
                            <span className="input-group-text w80">Subject:</span>
                          </div>
                          <input type="text" className="form-control" />
                        </div>
                        <div className="summernote">
                          Hi there,
                          <br />
                          <p>
                            The toolbar can be customized and it also supports various callbacks such as{" "}
                            <code>oninit</code>, <code>onfocus</code>, <code>onpaste</code> and many more.
                          </p>
                          <br />
                          <p>Thank you!</p>
                          <h6>Summer Note</h6>
                        </div>
                        <button className="btn btn-default mt-3 rh-btn rh-btn-red">Send</button>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-5 col-lg-6 col-md-12">
                    <div className="card rh-card">
                      <div className="card-header rh-card-head">
                        <h3 className="card-title">RNDSON Stats</h3>
                        <div className="card-options">
                          <a href="javascript:void(0)" className="card-options-remove" data-toggle="card-remove">
                            <i className="fa fa-times" />
                          </a>
                          <MoreMenu />
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row text-center">
                          <div className="col-lg-4 col-4 border-right">
                            <label className="mb-0 font-10">Department</label>
                            <h4 className="font-20 font-weight-bold">05</h4>
                          </div>
                          <div className="col-lg-4 col-4 border-right">
                            <label className="mb-0 font-10">Total Teacher</label>
                            <h4 className="font-20 font-weight-bold">43</h4>
                          </div>
                          <div className="col-lg-4 col-4">
                            <label className="mb-0 font-10">Total Student</label>
                            <h4 className="font-20 font-weight-bold">267</h4>
                          </div>
                        </div>
                        <table className="table table-striped mt-4">
                          <tbody>
                            {[
                              ["Mechanical Engineering", 43, 43, "bg-indigo"],
                              ["Business Analysis - BUS ", 27, 27, "bg-blue"],
                              ["Computer Technology - CT ", 81, 77, "bg-cyan"],
                              ["Management - MGT ", 61, 77, "bg-pink"],
                              ["Science ", 77, 77, "bg-orange"],
                            ].map(([name, pct, now, color]) => (
                              <tr key={name}>
                                <td>
                                  <label className="d-block">
                                    {name}
                                    <span className="float-right">{pct}%</span>
                                  </label>
                                  <div className="progress progress-xs">
                                    <div
                                      className={`progress-bar ${color}`}
                                      role="progressbar"
                                      aria-valuenow={now}
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                      style={{ width: `${pct}%` }}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="card-footer rh-card-foot">
                        <small>
                          Measure How Fast You’re Growing Monthly Recurring Revenue. <a href="#">Learn More</a>
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-12 col-lg-12">
                    <div className="card rh-card">
                      <div className="table-responsive todo_list rh-table-wrap">
                        <table className="rh-table table table-hover text-nowrap table-striped table-vcenter mb-0">
                          <thead>
                            <tr>
                              <th>Task</th>
                              <th className="w150 text-right">Due</th>
                              <th className="w100">Priority</th>
                              <th className="w80 text-center">
                                <i className="icon-user" />
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {[
                              ["Report Panel Usag", "Feb 12-2024", "danger", "HIGH", true, { pink: true }],
                              ["Report Panel Usag", "Feb 18-2024", "warning", "MED", false, { img: "avatar1.jpg" }],
                              ["New logo design for Angular Admin", "March 02-2024", "success", "High", true, { img: "avatar2.jpg" }],
                              ["Report Panel Usag", "Feb 12-2024", "danger", "HIGH", true, { pink: true }],
                              ["Report Panel Usag", "Feb 18-2024", "warning", "MED", false, { img: "avatar3.jpg" }],
                              ["New logo design for Angular Admin", "March 02-2024", "success", "High", true, { blue: true }],
                              ["Design PSD files for Angular Admin", "March 20-2024", "warning", "MED", false, { img: "avatar4.jpg" }],
                              ["Design PSD files for Angular Admin", "March 20-2024", "warning", "MED", false, { img: "avatar5.jpg" }],
                            ].map(([task, due, tag, prio, checked, av], i) => (
                              <tr key={i}>
                                <td>
                                  <label className="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      name="example-checkbox1"
                                      defaultValue="option1"
                                      defaultChecked={checked}
                                    />
                                    <span className="custom-control-label">{task}</span>
                                  </label>
                                </td>
                                <td className="text-right">{due}</td>
                                <td>
                                  <span className={`tag tag-${tag} ml-0 mr-0`}>{prio}</span>
                                </td>
                                <td>
                                  {av.img ? (
                                    <img
                                      src={`../assets/images/xs/${av.img}`}
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title
                                      alt="Avatar"
                                      className="avatar"
                                      data-original-title="Avatar Name"
                                    />
                                  ) : (
                                    <span
                                      className={`avatar ${av.pink ? "avatar-pink" : "avatar-blue"}`}
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title
                                      data-original-title="Avatar Name"
                                    >
                                      NG
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ================= FOOTER ================= */}
        <div className="section-body">
          <footer className="footer rh-footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025 <a href="">Technology support By - Siance Software Pvt Ltd</a>.
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
export default Home;
